import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './styles.module.scss'

class Tip extends Component {
  render() {
    const { t, classHr, text, position } = this.props
    return (
      <React.Fragment>
        {(position === 'bottom' || !position) && (
          <React.Fragment>
            <hr className={classHr ? classHr : styles.separator} />
            <div className={`${styles.tipWrapper} ${styles.bottom}`}>
              <h1 className={styles.title}>{t('tip.title')}</h1>
              <p className={styles.text}>{text}</p>
            </div>
          </React.Fragment>
        )}
        {position === 'right' && (
          <React.Fragment>
            <div className={`${styles.tipWrapper} ${styles.right}`}>
              <h1 className={styles.title}>{t('tip.title')}</h1>
              <p className={styles.text}>{text}</p>
            </div>
          </React.Fragment>
        )}
        {position === 'left' && (
          <React.Fragment>
            <div className={`${styles.tipWrapper} ${styles.left}`}>
              <h1 className={styles.title}>{t('tip.title')}</h1>
              <p className={styles.text}>{text}</p>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

const ExtendedComponent = withTranslation('common')(Tip)
export { ExtendedComponent as Tip }
